/*import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const DeallistRepository = RepositoryFactory.get('deallist');*/
import Vue from 'vue';

const state = {
    selectedRows: {},
    selectedFilter: [],
    selectedFilterArchived: [],
    finalFilter: [], //final filter für tabellenansicht
    finalFilterArchived: [], //final filter für tabellenansicht in der archivierten tabelle,
    columns: [
        {name: 'deal_name', display_name: 'Deal Name'},
        {name: 'deal_id', display_name: 'Deal ID'},
        {name: 'advertiser', display_name: 'Advertiser'},
        {name: 'deal_type', display_name: 'Deal Type'},
        {name: 'placement', display_name: 'Placement'},
        {name: 'device', display_name: 'Device'},
        {name: 'seat', display_name: 'Seat'},
        {name: 'seat_id', display_name: 'Seat ID'},
        {name: 'dsp', display_name: 'DSP'},
        {name: 'format', display_name: 'Format'},
        {name: 'branding', display_name: 'Transparenz'},
        {name: 'cpm', display_name: 'CPM'},
        {name: 'ssp', display_name: 'SSP'},
        {name: 'budget', display_name: 'Budget'},
        {name: 'targeting', display_name: 'Targeting'},
        {name: 'start', display_name: 'Start'},
        {name: 'end', display_name: 'End'},
        {name: 'agency', display_name: 'Agentur'},
        {name: 'agency_group', display_name: 'Agentur Gruppe'},
        {name: 'salesoffice', display_name: 'Internationale Kennung'},
        {name: 'reporting', display_name: 'Reporting'},
        {name: 'contact', display_name: 'Ansprechpartner'},
        {name: 'trafficker', display_name: 'Trafficker'},
        {name: 'opp_id', display_name: 'Opp ID'},
        {name: 'id', display_name: 'Datenbank ID'},
    ],
    dropdowns: null,
};

const getters = {
    distinctDSPs() {
        let ret = state.dropdowns ? [...new Set(state.dropdowns.find(x => x.name === 'seats').data.map(item => item.dsp))] : [];
        if (ret.length !== 0) {
            ret = ret.map((x) => {
                return {name: x}
            });
        }
        return ret;
    }
}

// actions
const actions = {};

// mutations
const mutations = {
    updateSelectedRows(state, data) {
        state.selectedRows = data;
    },
    updateSelectedFilter(state, data) {
        Vue.set(state, (data.archived ? 'selectedFilterArchived' : 'selectedFilter'), data.data);
    },
    updateFinalFilter(state, data) {
        Vue.set(state, (data.archived ? 'finalFilterArchived' : 'finalFilter'), data.data);
    },
    updateDropdowns(state, data) {
        state.dropdowns = data;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}